import { PdfJsLib } from '../types';
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

let isConfigured = false;
let cachedPdfJs: PdfJsLib | null = null;

const ensurePromiseTry = () => {
  const promiseCtor = Promise as PromiseConstructor & {
    try?: (fn: (...args: unknown[]) => unknown, ...args: unknown[]) => Promise<unknown>;
  };

  if (typeof promiseCtor.try === 'function') {
    return;
  }

  promiseCtor.try = (fn: (...args: unknown[]) => unknown, ...args: unknown[]) =>
    new Promise((resolve, reject) => {
      try {
        resolve(fn(...args));
      } catch (error) {
        reject(error);
      }
    });
};

export const loadPdfJs = async (): Promise<PdfJsLib> => {
  if (cachedPdfJs) {
    return cachedPdfJs;
  }

  // Must run before PDF.js module evaluation, since PDF.js references Promise.try.
  ensurePromiseTry();
  const pdfjsModule = await import('pdfjs-dist/legacy/build/pdf.mjs');
  const pdfjs = pdfjsModule as unknown as PdfJsLib;

  if (!isConfigured) {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
    isConfigured = true;
  }

  cachedPdfJs = pdfjs;
  return pdfjs;
};
